import { useSyncExternalStore } from 'react';

interface Store<T> {
  subscribe: (listener: () => void) => () => void;
  getSnapshot: () => T;
}

const useStore = <T, R>(store: Store<T>, selector: (state: T) => R): R =>
  useSyncExternalStore(store.subscribe, () => selector(store.getSnapshot()));

export default useStore;
